module.exports = "<h1 id=\"time指令\">time指令</h1>\n<h2 id=\"何时使用\">何时使用</h2>\n<p>当需要显示一个时间对象时</p>\n";